import { render, staticRenderFns } from "./wxShare.vue?vue&type=template&id=7ebda6cf&scoped=true&"
import script from "./wxShare.vue?vue&type=script&lang=js&"
export * from "./wxShare.vue?vue&type=script&lang=js&"
import style0 from "./wxShare.vue?vue&type=style&index=0&id=7ebda6cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebda6cf",
  null
  
)

export default component.exports